import axios from "axios";

export const API = process.env.REACT_APP_API_URL || "http://localhost:8000";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("contrack_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let isRedirecting = false;

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err.response?.status === 401) {
      const url = err.config?.url || "";
      const isAuthRoute = url.includes("/auth/login") || url.includes("/auth/register") || url.includes("/auth/token/refresh");

      if (!isAuthRoute && !isRedirecting) {
        // Prøv refresh token først
        const refreshToken = localStorage.getItem("contrack_refresh_token");
        if (refreshToken && !err.config._retried) {
          try {
            err.config._retried = true;
            const res = await axios.post(`${API}/auth/token/refresh`, { refresh_token: refreshToken });
            localStorage.setItem("contrack_token", res.data.access_token);
            if (res.data.refresh_token) localStorage.setItem("contrack_refresh_token", res.data.refresh_token);
            err.config.headers.Authorization = `Bearer ${res.data.access_token}`;
            return api(err.config);
          } catch {
            // Refresh feilet — sesjon er revokert (logget inn fra annen enhet)
          }
        }

        isRedirecting = true;
        localStorage.removeItem("contrack_token");
        localStorage.removeItem("contrack_refresh_token");
        localStorage.removeItem("contrack_user");
        alert("Du ble logget ut fordi kontoen din ble brukt fra en annen enhet.");
        window.location.reload();
      }
    }
    return Promise.reject(err);
  }
);

/**
 * Hent en lesbar feilmelding fra en axios-feil.
 * Håndterer:
 * - String-detail (vanlig HTTPException)
 * - Pydantic 422 (array av {loc, msg, ...})
 * - Strukturert plan-enforcement detail ({error, message, limit, current, plan})
 */
export function getErrorMessage(err: any, fallback = "Noe gikk galt"): string {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x: any) => x?.msg || JSON.stringify(x)).join("; ");
  if (typeof d === "object") return d.message || d.error || JSON.stringify(d);
  return String(d);
}

export default api;
